import "./js/Proto.cjs";
import { loadFonts } from "./plugins/webfontloader";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/router";
import vuetify from "./plugins/vuetify";
import global_dialog from "./components/helpers/global_dialog";
import mitt from "mitt";

import LoadingComponent from "./components/helpers/LoadingComponent.vue";
import ErrorComponent from "./components/helpers/ErrorComponent.vue";
import TTextField from "./components/helpers/TTextField.vue";
import TDateRangeInput from "./components/helpers/TDateRangeInput.vue";
import TNumberRangeInput from "./components/helpers/TNumberRangeInput.vue";
import TColorInput from "./components/helpers/TColorInput.vue";
import TDivider from "./components/helpers/TDivider.vue";
import TFilters from "./components/helpers/filters/TFilters";
import TCheckbox from "./components/helpers/TCheckBox.vue";
import StationList from "./components/StationList.vue";
import TBtn from "./components/helpers/TBtn.vue";
import ChargeStationCard from "./components/ChargeStationCard.vue";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import VueColumnsResizableVuetify from "vue-columns-resizable-vuetify";
import JsonViewer from "vue3-json-viewer";
import VueApexCharts from "vue3-apexcharts";
import "vue3-json-viewer/dist/index.css";
import DataManager from "./data/DataManager";
import HTTPSender from "./js/HTTPSender";

loadFonts();

const $emitter = mitt();
export let bus = $emitter;

const g_dialog = new global_dialog();
export let g_Dialog = g_dialog;

const g_events = {
  ChargePointRefresh: "ChargePointRefresh",
};
export let g_Events = g_events;

var g_IF = {
  Font: 2,
  Density: "compact",
  ShowTooltips: false,
  ShowSums: false,
  MultiSort: false,
  StartPage: "DashBoard",

  ShowMenu: false,
  get Dense() {
    return this.Density == "compact";
  },
  set Dense(newValue) {
    this.Density = newValue ? "compact" : "default";
  },

  get MyFontTitle() {
    switch (this.Font) {
      case 1:
        return "text-body-2";
      case 2:
        return "text-body-1";
      case 3:
      default:
        return "text-h6";
    }
  },
  get MyIconSize() {
    return 20 + this.Font * 6;
  },
  get MyFont() {
    switch (this.Font) {
      case 1:
        return "text-caption";
      case 2:
        return "text-body-2";
      case 3:
      default:
        return "text-body-1";
    }
  },
  DarkMode: false,
  // get DarkMode() {
  //   return vuetify.theme.global.name == "dark";
  // },
  // set DarkMode(newValue) {
  //   vuetify.theme.global.name = newValue ? "dark" : "light";
  //   localStorage.setItem("DarkMode", newValue);
  // },
  Test: false,
};

// IconColor: () => (this.isInDarkMode ? "rgb(22, 133, 201)" : "rgb(0, 46, 110)"),
// MenuTextColor: () => (this.isInDarkMode ? "" : "rgb(0, 46, 110)"),

const app = createApp(App);
app.mixin({
  data() {
    return {
      // dialog: g_dialog,
      IF: g_IF,
      wWidth: window.innerWidth,
      wHeight: window.innerHeight,
      rect: {
        top: 48,
        left: 280,
        bottom: 0,
        right: 0,
      },
      wLandscape: window.innerWidth > window.innerHeight,
      bus: bus,
    };
  },
  computed: {
    Colors() {
      return this.isInDarkMode
        ? {
            Background: "#fff",
            IconColor: "rgb(0, 152, 70)", //"rgb(22, 133, 201)",
            MenuTextColor: "",
            ActiveItemBackground: "#114422",
            ActiveItemBackground2: "#003311",
            MenuColor: "", //"rgb(20, 10, 20)",
          }
        : {
            Background: "#000",
            IconColor: "rgb(0, 152, 70)", //"rgb(0, 46, 110)",
            MenuTextColor: "", // "rgb(55, 100, 5)",
            ActiveItemBackground: "#D5EBBA", //"rgb(140, 198, 63)",
            ActiveItemBackground2: "#C4DAA9", //"rgb(140, 198, 63)",
            MenuColor: "rgb(240, 250, 235)", //rgb(230, 246, 250)",
          };
    },

    isInDarkMode: {
      get() {
        return this.IF.DarkMode;
      },
      set(v) {
        this.IF.DarkMode = v;
      },
    },
    isOnTestServer: {
      get() {
        return this.IF.Test;
      },
      set(testServer) {
        this.IF.Test = testServer;
        if (testServer) {
          HTTPSender.URL = "https://router.tremol.bg:38091/API2/";
          HTTPSender.URL_OLD = "https://router.tremol.bg:38091/API/";
        } else {
          HTTPSender.URL = "https://ev.tremol.bg/OCPP/API2/";
          HTTPSender.URL_OLD = "https://ev.tremol.bg/OCPP/API/";
        }

        // if (this.$router.currentRoute && this.$router.currentRoute.name == "DashBoard") {
        //   this.$router.push({ name: "MainContent" });
        // }
        // this.$nextTick(() => {
        //   this.$router.push({ name: "DashBoard" });
        // });
      },
    },
    isOnMobile() {
      return this.$vuetify.display.mobile;
    },
    hideTooltips() {
      return !this.IF.ShowTooltips || this.isOnMobile;
    },
    isWithSmallWidth() {
      return this.wWidth <= 400;
    },
    mainContainerWidth() {
      return this.wWidth - this.rect.left - this.rect.right;
    },
    mainContainerHeight() {
      return this.wHeight - this.rect.top - this.rect.bottom;
    },
  },
  methods: {
    openWebSite(site) {
      window.open(site, "_blank");
    },
    isCapsLockOn(e) {
      // console.log(e);
      let caps = e.getModifierState && e.getModifierState("CapsLock");
      if (caps == true) return true;
      else return false;
    },

    requestFullScreen() {
      var elem = document.documentElement;
      if (this.isOnFullScreen == false) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    },
    mainWindowResizeEvent() {
      this.wWidth = window.innerWidth;
      this.wHeight = window.innerHeight;
      this.wLandscape = window.innerWidth > window.innerHeight;
    },
    fullScreenChanged() {
      if (document.fullScreen || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreen) {
        this.isOnFullScreen = true;
      } else {
        this.isOnFullScreen = false;
      }
    },
  },
  watch: {
    "IF.DarkMode": {
      handler(val, old_val) {
        if (old_val != undefined && val != old_val) {
          this.$vuetify.theme.global.name = val ? "dark" : "light";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.dialog = g_Dialog;

    document.addEventListener("fullscreenchange", this.fullScreenChanged);
    document.addEventListener("MSFullscreenChange", this.fullScreenChanged);
    window.addEventListener("resize", this.mainWindowResizeEvent);
    window.onbeforeunload = function () {
      if (!location.href.endsWith("login") && !DataManager.user) return "Your work will be lost.";
    };
  },
  mounted() {},
});

app.use(VueColumnsResizableVuetify);
app.use(VueApexCharts);
app.use(JsonViewer);
app.component("error-component", ErrorComponent);
app.component("loading-component", LoadingComponent);
app.component("t-text-field", TTextField);
app.component("t-date-range-input", TDateRangeInput);
app.component("t-number-range-input", TNumberRangeInput);
app.component("t-checkbox", TCheckbox);
app.component("t-color-input", TColorInput);
app.component("t-divider", TDivider);
app.component("t-filters", TFilters);
app.component("t-btn", TBtn);

app.component("split-panes", Splitpanes);
app.component("split-pane", Pane);

app.component("station-list", StationList);
app.component("charge-station-card", ChargeStationCard);

app.component("apex-chart", VueApexCharts);

app.config.globalProperties.bus = bus;
// app.config.globalProperties.isOnMobile = () => vuetify.display.mobile;

app.use(router).use(vuetify).mount("#app");
